export default {
  bigModelSaleDetail: {  //大型号销量明细
    url: '/ec-pc-api/product/cycle/detail/bigModelSaleDetail',
    type: 'post'
  },
  bigModelSaleDetailExport: {  //大型号销量明细导出
    url: '/ec-pc-api/product/cycle/detail/bigModelSaleDetailExport',
    type: 'post'
  },
  bigModelEditor: {  //大型号明细编辑
    url: '/ec-pc-api/product/cycle/bigModelEditor',
    type: 'post'
  },
  queryMarketingCategory: {  //产品类别下拉
    url: '/ec-pc-api/product/cycle/queryMarketingCategory',
    type: 'get'
  },
  queryMarketingPositioning: {  //销售定位下拉
    url: '/ec-pc-api/product/cycle/queryMarketingPositioning',
    type: 'get'
  },
  productCodeMarketingPositioning: {  //产品销售定位下拉
    url: '/ec-pc-api/product/cycle/productCodeMarketingPositioning',
    type: 'get'
  },
  bigModelMarketingPositioning: {  //大型号销售定位下拉
    url: '/ec-pc-api/product/cycle/bigModelMarketingPositioning',
    type: 'get'
  },
  queryProductionStatus: {  //在产状态下拉
    url: '/ec-pc-api/product/cycle/queryProductionStatus',
    type: 'get'
  },
  queryBigModelHandlingCommentsRecord: {  //大型号处理意见操作记录
    url: '/ec-pc-api/product/cycle/queryBigModelHandlingCommentsRecord',
    type: 'post'
  },
  bigModelSalesPositioning: {  //大型号销售定位列表
    url: '/ec-pc-api/product/cycle/bigModelSalesPositioning',
    type: 'post'
  },
  
  productCycleSaleDetail: {  //产品销量明细
    url: '/ec-pc-api/product/cycle/detail/productCycleSaleDetail',
    type: 'post'
  },
  productEditor: {  //产品销量明细
    url: '/ec-pc-api/product/cycle/productEditor',
    type: 'post'
  },
  queryProductSaleDetailRecord: {  //产品处理意见查询
    url: '/ec-pc-api/product/cycle/queryProductSaleDetailRecord',
    type: 'get'
  },
  productSalesSituation: {  //产品销量情况
    url: '/ec-pc-api/product/cycle/productSalesSituation',
    type: 'post'
  },
  productCycleSaleDetailExport: {  //产品销量明细导出
    url: '/ec-pc-api/product/cycle/detail/productCycleSaleDetailExport',
    type: 'post'
  },
  bigModelSalesSituation: {  //大型号各店铺销量情况
    url: '/ec-pc-api/product/cycle/bigModel/salesSituation',
    type: 'post'
  },
  bigModelStoreOptions: {  //大型号销量明细-店铺下拉
    url: '/ec-pc-api/product/cycle/detail/bigModel/storeOptions',
    type: 'post'
  },
  productSelectStoreBox: {  //产品销量明细-店铺下拉框
    url: '/ec-pc-api/product/cycle/detail/productSelectStoreBox',
    type: 'post'
  },
  keyProductsMonitorSearch: {  //重点品监控分页查询
    url: '/ec-pc-api/keyProducts/monitor/search',
    type: 'post'
  },
  keyProductsMonitorExport: {  //重点品监控导出
    url: '/ec-pc-api/keyProducts/monitor/export',
    type: 'post'
  },
  keyProductsStoreSales: {  //重点品监控店铺销量详情
    url: '/ec-pc-api/keyProducts/monitor/store/sales',
    type: 'post'
  },
  keyProductsStoreSalesAmount: {  //重点品监控店铺销售金额详情
    url: '/ec-pc-api/keyProducts/monitor/store/salesAmount',
    type: 'post'
  },
  keyProductsListBigModelOptions: {  //大型号下拉
    url: '/ec-pc-api/keyProducts/monitor/listBigModelOptions',
    type: 'post'
  },
  keyProductsListCategoryOptions: {  //品类细分下拉
    url: '/ec-pc-api/keyProducts/monitor/listCategoryOptions',
    type: 'post'
  },
  
}